import metrics from '../../../core/utils/src/metrics';
metrics.initMetrics('react');
//# sourceMappingURL=metrics.js.map